import { BUSINESS } from "@/constants/business";
import { useLang } from "@/context/LangContext";
import { STRINGS } from "@/i18n";

export default function StickyBookBar() {
  const { lang } = useLang();
  const t = STRINGS[lang];
  return (
    <div
      data-testid="sticky-book-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 border-t border-white/10 bg-[#0d0906]/95 backdrop-blur-md px-4 py-3 flex gap-3"
    >
      <a
        data-testid="sticky-book-btn"
        href="#booking"
        className="flex-1 text-center py-3 bg-gradient-to-r from-[#800f2f] to-[#a4133c] text-white text-xs uppercase tracking-widest font-semibold rounded-lg"
      >
        {t.nav.requestSlot}
      </a>
      <a
        data-testid="sticky-whatsapp-btn"
        href={BUSINESS.whatsappHref}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        className="w-12 flex items-center justify-center border border-[#25D366]/50 text-[#25D366] rounded-lg"
      >
        <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
          <path d="M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.2 5.1 4.49.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35M12.05 21.8h-.01a9.9 9.9 0 0 1-5-1.37l-.36-.21-3.72.97.99-3.62-.23-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 0 1 6.99 2.9 9.82 9.82 0 0 1 2.9 7c0 5.45-4.45 9.88-9.9 9.88m8.42-18.3A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.94L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.16-3.47-8.4" />
        </svg>
      </a>
    </div>
  );
}
